import { reportValidationWarnings } from './report';
import { FieldParser, ValidationWarning } from './types';

export type SchemaRunResult<T> =
  | {
      ok: true;
      value: T;
      warnings: ReadonlyMap<string, ValidationWarning>;
    }
  | {
      ok: false;
      warnings: ReadonlyMap<string, ValidationWarning>;
    };

/**
 * Entry point for a thunk-level schema run. Allocates the warnings Map,
 * invokes the schema at the empty root path, reports the warnings via the
 * single swappable sink, and returns `{ ok, value?, warnings }`. The
 * `warnings` Map is exposed so callers can hand it to `enforce` (issue #806)
 * without re-walking the result.
 */
export const runSchema = <T>(schema: FieldParser<T>, raw: unknown, source: string): SchemaRunResult<T> => {
  const warnings = new Map<string, ValidationWarning>();
  const result = schema(raw, '', warnings);
  reportValidationWarnings(source, warnings.values());
  if (!result.ok) return { ok: false, warnings };
  return { ok: true, value: result.value, warnings };
};
